import * as _ from "lodash";
import {WB_EventSpendTypeRelationshipRow, WB_TPM_EventSpendTypeAccountRow,} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {EventSpendTypeBO} from "./EventSpendTypeBO";
import {EventTypeBO} from "./EventTypeBO";

export class EventTypeBOAudit {

    // Audit Log Service for User Group

    static EventTypeAuditBO(EventTypeBO: EventTypeBO): Promise<AuditService> {
        const self = EventTypeBO
        let tasks: any = []
        const auditService = new AuditService(new PAdbContext({}))
        auditService.setReference("EventType", self.drWB_EventType.cif.WB_EVTTYPE_ID)
        var sUsrName = 'Unknown'
        sUsrName = self.drWB_EventType.cif.TYPE_ID

        if (self.WB_EventType.isActiveNew) {
            tasks.push(auditService.Log(AuditLogType.CreateNew, 'Event Type Added, ' + sUsrName))
        }
        

        return new Promise<AuditService>((resolve, reject) => {

            // Accounts

            _.forEach(self.drWB_EventType.WB_EventSpendTypeRows, (aEvtSpndTypeRelRow: WB_EventSpendTypeRelationshipRow) => {
                // let sUsrName = 'Unknown'd
                if (aEvtSpndTypeRelRow.WB_EventType) {
                    sUsrName = aEvtSpndTypeRelRow.WB_EventType.cif.TYPE_ID
                }
                if (aEvtSpndTypeRelRow.isActiveNew) {
                    tasks.push(auditService.Log(AuditLogType.CreateNew, 'Event Type Account Added, ' + sUsrName))
                }
                if (aEvtSpndTypeRelRow.WB_EventType)
                    if (!aEvtSpndTypeRelRow.isActive && !aEvtSpndTypeRelRow.isNew() && !(aEvtSpndTypeRelRow.cif.WB_EVTSTYPR_ID in self.dctAuditedDeletes)) {
                        tasks.push(auditService.Log(AuditLogType.Delete, 'Event Type Account Deleted, ' + sUsrName))
                        self.dctAuditedDeletes[aEvtSpndTypeRelRow.cif.WB_EVTSTYPR_ID] = aEvtSpndTypeRelRow.cif.WB_EVTSTYPR_ID
                    }

                // Logging date changes in product
                let changedDates: string[] = ["EFFECTIVE_START_DT", "EFFECTIVE_END_DT"]
                let changedArr = aEvtSpndTypeRelRow.getChangedProperties({properties: changedDates})
                if (changedArr.length) {
                    _.forEach(changedArr, (fieldName: string) => {
                        let curValue = (<any>aEvtSpndTypeRelRow)[fieldName]
                        let prevValue = aEvtSpndTypeRelRow.previous(fieldName)
                        tasks.push(auditService.Log(AuditLogType.Change, `${fieldName} changed, key value changed from ${prevValue} to ${curValue}`))
                    })
                }

            })

            // Rate Settings , Workflow, UI Settings, Data Settngs, Other Settings

            let propsToCheck: string[] = ["SUBPLANNING_CUST_SHOW_IND", "COVERAGEFACTOR_LEVEL", "PLANNING_CUST_SHOW_IND", "MERCH_ACV_LEVEL",
                "COVERAGEFACTOR_SHOW_IND", "INSTOREDATES_SHOW_IND", "INSTOREDATES_POLICY", "SHIPMENTDATES_SHOW_IND", "SHIPMENTDATES_POLICY", "ORDERDATES_SHOW_IND",
                "ORDERDATES_POLICY", "DISTRIBUTIONDATES_SHOW_IND", "DISTRIBUTIONDATES_POLICY", "PAIDINFULL_SHOW_IND", "WB_WORKFLOW_ID", "DISPLAYS_SHOW_IND", "PRODUCTGROUPS_SHOW_IND", "PLANNED_SPEND_SHOW_IND",
                "APPROVED_SPEND_SHOW_IND", "ACTUAL_SPEND_SHOW_IND", "LE_SPEND_SHOW_IND", "COPY_POLICY", "WORKFLOW_POLICY", "TAGS_SHOW_IND", "WB_TAGS_ID_USAGES", "COMMENTS_SHOW_IND",
                "CREATOR_SHOW_IND", "PLAN_SHOW_IND", "PLAN_POLICY", "CALC_VOLUMELAYER_ID", "PGGROSSLISTPRICE_SHOW_IND", "PGNETLISTPRICE_SHOW_IND",
                "PGBASEPRICE_SHOW_IND", "PGBASEPRICE_POLICY", "PGEDLPPRICE_SHOW_IND", "PGEDLPPRICE_POLICY", "PGPROMOTEDPRICE_SHOW_IND", "PGPROMOTEDPRICE_POLICY",
                "PGDISCOUNTPCNT_SHOW_IND", "PGDISCOUNTPCNT_POLICY", "PGDISCOUNTAMT_SHOW_IND", "PGDISCOUNTAMT_POLICY", "PGCNSBASE_SHOW_IND", "PGCNSBASEEDLP_SHOW_IND", "PGCNSEDLP_SHOW_IND", "PGCNSEDLP_POLICY",
                "PGCNSINCR_SHOW_IND", "PGCNSINCR_POLICY", "PGCNSCANN_SHOW_IND", "PGCNSCANN_POLICY", "PGCNSTOTAL_SHOW_IND", "PGCNSTOTAL_POLICY", "PGSHPBASE_SHOW_IND", "PGSHPBASEEDLP_SHOW_IND",
                "PGSHPEDLP_SHOW_IND", "PGSHPEDLP_POLICY", "PGSHPINCR_SHOW_IND", "PGSHPINCR_POLICY", "PGSHPFWDBUYPCNT_SHOW_IND", "PGSHPFWDBUYPCNT_POLICY",
                "PGSHPFWDBUY_SHOW_IND", "PGSHPADJ_SHOW_IND", "PGSHPADJ_POLICY", "PGSHPTOTAL_SHOW_IND", "PGSHPTOTAL_POLICY", "PGSHPDISP_SHOW_IND", "PGSHPDISP_POLICY", "PGCNSLIFTPCNT_SHOW_IND",
                "PGCNSLIFTPCNT_POLICY", "PGCNSLIFTPCNTOVR_SHOW_IND", "PGCNSLIFTPCNTOVR_POLICY", "PGSHPFWDBUY_POLICY", "PGCNSVOL_POLICY", "PGSHPVOL_POLICY", "PROD_SHOW_IND", "CONSUMER_PRODUCT_POLICY",
                "FINISHED_PRODUCT_POLICY", "PRODUCT_PERIOD_PRDTYPES","PROD_PERIOD_SHOW_IND"];
            let changedArr = self.drWB_EventType.getChangedProperties({properties: propsToCheck})
            if (changedArr.length) {
                _.forEach(changedArr, (fieldName: string) => {
                    let curValue = (<any>self.drWB_EventType)[fieldName]
                    let prevValue = self.drWB_EventType.previous(fieldName)
                    tasks.push(auditService.Log(AuditLogType.Change, `${fieldName} changed, key value changed from ${prevValue} to ${curValue}`))
                })
            }

            Promise.all(tasks)
                .then(res => {
                    return auditService.Save();
                })
                .then(res => {
                    resolve(auditService)
                })
                .catch(error => {
                    reject()
                })
        })

    }

}
